import type { ButtonProps as MuiButtonProps } from '@mui/material';

import type { ButtonProps } from './Button';

export const getVariantStyles = (
  variant: ButtonProps<'button'>['variant']
): {
  variant: MuiButtonProps<'button'>['variant'];
  color: MuiButtonProps<'button'>['color'];
} => {
  if (!variant) {
    return { color: 'primary', variant: 'contained' };
  }

  switch (variant) {
    case 'primary':
      return {
        color: 'primary',
        variant: 'contained',
      };

    case 'secondary':
      return {
        color: 'secondary',
        variant: 'outlined',
      };

    case 'text':
      return {
        color: 'secondary',
        variant: 'text',
      };

    default:
      return { color: 'primary', variant: variant };
  }
};
